import FilesList from './FilesList';

export default FilesList;
